var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOxidizer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#ffce6e}.cls-2{fill:#ff462e}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "oxidizer",
    transform: "translate(.174 -.06)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    cx: 30,
    cy: 30,
    r: 30,
    className: "cls-1",
    transform: "translate(-.174 .06)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_11_Oxidizing_Agent",
    transform: "translate(12.335 6.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1630",
    d: "M43.329 24.244a.757.757 0 0 0-.833.208 4.879 4.879 0 0 1-2.008 1.31c.553-1.426 1.049-4.107-.681-7.721a.757.757 0 0 0-1.4.087 8.821 8.821 0 0 1-1.374 2.581c1.2-7.57-4.14-11.569-9.311-15.442-.908-.681-1.844-1.381-2.739-2.1a.757.757 0 0 0-1.238.586c0 3.063-1.829 5.031-3.764 7.115-2.263 2.436-4.8 5.164-4.163 9.865a8.75 8.75 0 0 1-1.4-2.61.757.757 0 0 0-1.4-.087c-1.733 3.617-1.237 6.3-.681 7.721a4.873 4.873 0 0 1-2.007-1.309.757.757 0 0 0-1.331.5 13.156 13.156 0 0 0 4.851 10.585.757.757 0 0 0 1.239-.638c-.021-.285-.036-.568-.036-.86a11.354 11.354 0 1 1 22.709 0c0 .291-.014.575-.036.86a.757.757 0 0 0 1.239.638 13.156 13.156 0 0 0 4.852-10.582.757.757 0 0 0-.49-.708z",
    className: "cls-2",
    transform: "translate(-8.993 -2.998)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9",
    cx: 12.833,
    cy: 12.883,
    className: "cls-2",
    rx: 12.833,
    ry: 12.883,
    transform: "translate(4.581 18.172)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10",
    cx: 10,
    cy: 9.5,
    className: "cls-1",
    rx: 10,
    ry: 9.5,
    transform: "translate(7.491 21.71)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxidizer);
export default __webpack_public_path__ + "static/media/oxidizer.fb135ba9cc6d5e05f64355f7d69f9a2c.svg";
export { ForwardRef as ReactComponent };